import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import DepartmentService from "../../shared/service/DepartmentService";
import '../../shared/styles/SettingsPage.css';

export default class DepartmentTransfer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transferDepartmentList: [], transferDepartmentId: null, departmentId: null
        }
        this.departmentService = new DepartmentService();
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="settings-page settings-page--dialog">
                <h2 className="settings-page__section-title">Transfer Department</h2>

                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="transfer-department">
                                    <Translate contentKey="contactManagement.mobilePhone">Department</Translate>
                                </Label>
                                <AvField
                                    id="transfer-department"
                                    type="select"
                                    disabled={false}
                                    className="form-control"
                                    name="transferDepartmentId"
                                    value={this.state.transferDepartmentId}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {this.state.transferDepartmentList.map(element => (
                                        <option value={element.id} key={element.id}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="settings-page__actions">
                    <Button color="outline-primary" className="settings-page__btn--delete" onClick={() => {
                        this.delete()
                    }}>
                        <Translate contentKey="entity.action.add">Delete</Translate>
                    </Button>
                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close" onClick={() => {
                        this.props.closeDisplayDialog();
                    }}>
                        <Translate contentKey="entity.action.cancel">Cancel</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    setDepartmentId = (departmentId) => {
        this.setState({departmentId: departmentId});
        this.departmentService.findAll().then(response => this.setState({
            transferDepartmentList: this.filterDepartmentId(response, departmentId)
        }));
    }

    filterDepartmentId = (response, departmentId) => {
        return response.filter(function (el) {
            return el.id != departmentId;
        });
    }

    delete = () => {
        let transferDepartmentId = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.transferDepartmentId)) {
            transferDepartmentId = this.state.transferDepartmentId;
        }
        this.departmentService.deleteAndTransfer(this.state.departmentId, transferDepartmentId)
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    window.location.href = "#departmentList";
                }
            });
        return undefined;
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({transferDepartmentId: value});
    }
}

DepartmentTransfer.propTypes = {
    order: PropTypes.object
};
